import { ArrowRight } from '@mui/icons-material';
import { Avatar, Button, Link, ListItemText, MenuItem, Skeleton, styled } from '@mui/material';
import { ITheme } from 'theme/types';

const wrapTextStyles = {
  whiteSpace: 'nowrap' as const,
  overflow: 'hidden' as const,
  textOverflow: 'ellipsis' as const,
};

export const StyledAvatar = styled(Avatar)({
  backgroundColor: 'transparent',
  border: '2px solid #fff',
  fontWeight: 700,
  fontSize: '1rem',
});

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    ...wrapTextStyles,
    color: (theme as unknown as ITheme).palette.white,
    fontWeight: 700,
  },
  '& .MuiListItemText-secondary': {
    ...wrapTextStyles,
  },
}));

export const SecondaryLink = styled(Link)(({ theme }) => ({
  color: (theme as unknown as ITheme).palette.white,
  textTransform: 'none',
  fontWeight: 'normal',
  fontSize: '0.8rem',
  justifyContent: 'flex-start',
  padding: `${theme.spacing(0.2)} 0`,
  marginTop: theme.spacing(0.5),
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const SecondaryButton = styled(Button)(({ theme }) => ({
  color: (theme as unknown as ITheme).palette.white,
  textTransform: 'none',
  fontWeight: 'normal',
  fontSize: '0.8rem',
  justifyContent: 'flex-start',
  padding: `${theme.spacing(0.2)} 0`,
  marginTop: theme.spacing(0.5),

  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledArrowRight = styled(ArrowRight)(({ theme }) => ({
  color: (theme as unknown as ITheme).palette.white,
}));

export const MenuItemsLabel = styled(MenuItem)(({ theme }) => ({
  fontFamily: (theme as unknown as ITheme).typography.secondaryFont,
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '0.75rem', // SMALL_FONT_SIZE equivalent
  lineHeight: '16px',
  textTransform: 'uppercase',
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  fontFamily: (theme as unknown as ITheme).typography.secondaryFont,
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: '1rem',
  lineHeight: '30px',
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: 'rgba(255,255,255,0.5)',
}));
